<template>
  <div class="mt-16 flex min-h-screen flex-1 flex-col xl:mt-0">
    <Header is-error />

    <main class="w-full 2.5xl:mx-auto 2.5xl:max-w-[1920px]">
      <div
        class="container mt-14 grid grid-cols-12 gap-[20px] py-[40px] xl:pb-[200px]"
      >
        <div class="col-span-2 hidden max-w-[290px] xl:block">
          <CommonLeftMenu />
        </div>

        <div class="col-span-full max-w-[1530px] text-center xl:col-span-8">
          <slot />
        </div>
        <CommonBlocksRightArticleBlock
          class="col-span-2 hidden xl:block"
          articles-per-page="4"
          video-per-page="0"
          disable-social
          disable-table
        />
      </div>
    </main>
    <Footer />
  </div>
</template>

<script setup></script>
